import React from "react";

const Experience = () => {
  return (
    <div
      name="experience"
      className="w-full bg-gradient-to-b from-black via-gray to-gray-800"
    >
      <div class="max-w-screen-lg mx-auto p-4 pt-5 flex flex-col justify-center w-full h-full text-white">
        <div className="text-center">
          <h2 className="text-2xl sm:text-5xl lg:text-4xl lg:mt-5 mb-5  tracking-wide">
            Work experience{" "}
            <span className="bg-gradient-to-r from-teal-500 to-teal-800 text-transparent  bg-clip-text">
              & skills
            </span>
          </h2>
          {/* <p className="">These are the technolohies I've worked with</p> */}
        </div>

        <div class="flex flex-col grid-cols-9 p-2 mx-auto md:grid">
          <div class="flex md:contents flex-row-reverse ">
            <div class="relative p-4 my-6 text-white-800 bg-[#333333]/40 rounded-xl col-start-1 col-end-5 mr-auto md:mr-0 md:ml-auto">
              <h3 class="text-md font-semibold lg:text-md">
                July 2022 - Currently working
              </h3>
              <p class="mt-2 leading-6 font-bold">
                Star Health and Allied Insurance{" "}
              </p>
              <p class="text-sm text-neutral-500">Software Engineer </p>
            </div>
            <div class="relative col-start-5 col-end-6 mr-7 md:mx-auto">
              <div class="flex items-center justify-center w-6 h-full">
                <div class="w-1 h-full bg-white rounded-t-full bg-gradient-to-b from-white to-teal-500"></div>
              </div>
              <div class="absolute w-6 h-6 -mt-3 bg-teal-500 border-4 border-white rounded-full top-1/2"></div>
            </div>
          </div>

          <div class="flex md:contents">
            <div class="relative col-start-5 col-end-6 mr-7 md:mx-auto">
              <div class="flex items-center justify-center w-6 h-full">
                <div class="w-1 h-full bg-gradient-to-b from-white to-teal-500"></div>
              </div>
              <div class="absolute w-6 h-6 -mt-3 bg-teal-500 border-4 border-white-400 rounded-full top-1/2"></div>
            </div>
            <div class="relative p-4 my-6 text-white-800 bg-[#333333]/40 rounded-xl col-start-6 col-end-10 mr-auto">
              <h3 class="text-md font-semibold lg:text-md">
                July 2018 - June 2022
              </h3>
              <p class="mt-2 leading-6 font-bold">
                Dr. A. P. J. Abdul Kalam Technical University{" "}
              </p>
              <p class="text-sm text-neutral-500 ">
                B Tech (Computer Science & Engineering)
              </p>
            </div>
          </div>

          <div class="flex md:contents flex-row-reverse">
            <div class="relative p-4 my-6 text-white-800 bg-[#333333]/40 rounded-xl col-start-1 col-end-5 mr-auto md:mr-0 md:ml-auto">
              <h3 class="text-md font-semibold lg:text-md">
                July 2016 - June 2018{" "}
              </h3>
              <p class="mt-2 leading-6 font-bold">
                Uttar Pradesh Madhyamik Shiksha Parishad
              </p>
              <p class="text-sm text-neutral-500">Intermediate (PCM)</p>
            </div>
            <div class="relative col-start-5 col-end-6 mr-7 md:mx-auto">
              <div class="flex items-center justify-center w-6 h-full">
                <div class="w-1 h-full bg-white rounded-t-full bg-gradient-to-b from-white to-teal-500"></div>
              </div>
              <div class="absolute w-6 h-6 -mt-3 bg-teal-500 border-4 border-white rounded-full top-1/2"></div>
            </div>
          </div>

          <div class="flex md:contents">
            <div class="relative col-start-5 col-end-6 mr-7 md:mx-auto">
              <div class="flex items-center justify-center w-6 h-full">
                <div class="w-1 h-full bg-gradient-to-b from-white to-teal-500"></div>
              </div>
              <div class="absolute w-6 h-6 -mt-3 bg-teal-500 border-4 border-white rounded-full top-1/2"></div>
            </div>
            <div class="relative p-4 my-6 text-white-800 bg-[#333333]/40 rounded-xl col-start-6 col-end-10 mr-auto">
              <h3 class="text-md font-semibold lg:text-md">
                July 2014 - June 2016
              </h3>
              <p class="mt-2 leading-6 font-bold">
                Uttar Pradesh Madhyamik Shiksha Parishad
              </p>
              <p class="text-sm text-neutral-500">High School (PCM)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
